import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import { ThemeContext } from 'utils/theme';
import ProjectModel from 'models/Project';
import PageTransition from 'containers/PageTransition';
import Head from 'components/Head';
import SlidingPageTransition from 'components/SlidingPageTransition';
import TagsSection from 'components/TagsSection';
import HeadingSection from 'components/HeadingSection';
import MarkdownSection from 'components/MarkdownSection';
import GallerySection from 'components/GallerySection';
import VideoSection from 'components/VideoSection';
import QuoteSection from 'components/QuoteSection';
import Hero from 'components/Hero';

import Link from 'next/link';
import Wrapper from './styled/Wrapper';
import ContentWrapper from './styled/ContentWrapper';
import InnerContentWrapper from './styled/InnerContentWrapper';
import Background from './styled/Background';
import BurgerButton from './styled/BurgerButton';
import BurgerMenu from './styled/BurgerMenu';
import SecondaryFooter from './styled/SecondaryFooter';
import CaseStudyWrapper from './styled/CaseStudyWrapper';
import HomeButton from './styled/HomeButton';
import Separator from './styled/Separator';

export default class CaseStudyPage extends PureComponent {
  constructor() {
    super();
    // this.getSectionComponent = this.getSectionComponent.bind(this);
  }
  static defaultProps = {
    project: {},
    footer: {
      nextLink: {
        link: '/process',
        label: 'Our process',
      },
      prevLink: {
        link: '/capabilities',
        label: 'Offer',
      },
    },
  };

  static contextType = ThemeContext;

  getSectionComponent = (section, key) => {
    const SectionComponent = CaseStudyPage.sectionsMapping[section.__typename];

    if (SectionComponent) {
      return React.createElement(SectionComponent, {
        key: `${key}-${section.__typename}`,
        ...section,
        heightSetter:
          SectionComponent === VideoSection
            ? height => this.setState({ height: height })
            : null,
        videoHeight: SectionComponent === GallerySection && this.state.height,
      });
    }

    console.warn(`No section found for section ${section.__typename}`);
    return null;
  };

  static sectionsMapping = {
    ComponentContentsHeadingSection: HeadingSection,
    ComponentContentsContent: MarkdownSection,
    ComponentContentsGallerySection: GallerySection,
    ComponentContentsQuoteSection: QuoteSection,
    ComponentContentsVideo: VideoSection,
  };

  state = {
    isMenuVisible: false,
    marginTop: 0,
    height: 0,
  };

  componentDidMount() {
    const { router } = this.props;

    this.onResize();
    window.addEventListener('resize', debounce(this.onResize, 300));
    // if(appState.analytics)appState.analytics._trackPageView( router.pathname.replace('[slug]', router.query.slug));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.setState({
      marginTop: 0,
    });

    setTimeout(() => {
      const tagTitle = document.getElementById('tagTitle');
      const rightSideContent =
        document.getElementById('rightSideContent').childNodes[0];

      const rect1 = tagTitle.getBoundingClientRect().top;
      const rect2 = rightSideContent.getBoundingClientRect().top;

      this.setState({
        marginTop: rect1 - rect2,
      });
    }, 100);
  };

  onBurgerClick = () => {
    const { isMenuVisible } = this.state;
    this.setState({ isMenuVisible: !isMenuVisible });
    // if(appState.analytics)appState.analytics._trackEvent('CaseStudyPage', 'click burger');
  };

  onTopClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // if(appState.analytics)appState.analytics._trackEvent('CaseStudyPage', 'click top');
  };

  render() {
    const { navLinks, project, footerLinkPrev, footerLinkNext, router } =
      this.props;
    const { isMenuVisible, marginTop } = this.state;
    const { caseStudy } = project;
    const { contents, images, heroMedia } = caseStudy;

    const { ogTags } = caseStudy;
    ogTags.image = project.image;

    return (
      <>
        <Head ogTags={ogTags} router={router} />
        {/* <PageTransition router={router} component={SlidingPageTransition}> */}
        <Wrapper theme={this.context} dark={isMenuVisible}>
          <ContentWrapper hidden={isMenuVisible}>
            <Background blank />
            <Hero {...heroMedia} />
            <InnerContentWrapper lowerMargin={heroMedia?.url?.length}>
              <TagsSection {...project} />
              <CaseStudyWrapper id="rightSideContent" marginTop={marginTop}>
                {contents.map((section, index) =>
                  this.getSectionComponent(section, index)
                )}
                <Separator theme={this.context} />
              </CaseStudyWrapper>
            </InnerContentWrapper>
            <GallerySection
              showArrows={true}
              maxImages={1}
              images={images}
              orientation="landscape"
              big
            />
            <SecondaryFooter
              prevLink={footerLinkPrev}
              nextLink={footerLinkNext}
              onTopButtonClick={this.onTopClick}
            />
          </ContentWrapper>
          <BurgerMenu
            router={router}
            items={navLinks}
            light={false}
            hidden={!isMenuVisible}
          />
          <BurgerButton
            isActive={isMenuVisible}
            light={!isMenuVisible}
            onClick={this.onBurgerClick}
          />
          <Link href="/" passHref>
            <HomeButton />
          </Link>
        </Wrapper>
        {/* </PageTransition> */}
      </>
    );
  }
}
